var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4029_4197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.6895C18.6274 24.6895 24 19.3169 24 12.6895C24 6.06204 18.6274 0.689453 12 0.689453C5.37258 0.689453 0 6.06204 0 12.6895C0 19.3169 5.37258 24.6895 12 24.6895Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 12.6894C23.9999 7.93188 21.2312 3.82113 17.2173 1.88013V23.4986C21.2312 21.5577 23.9999 17.4469 23.9999 12.6894Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.6894C0 17.4469 2.76867 21.5577 6.78263 23.4987V1.88013C2.76867 3.82113 0 7.93188 0 12.6894Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.087 14.2547L16.174 13.2112L15.1305 12.6895V11.646L13.0435 12.6895L14.087 10.6026H13.0435L12.0001 9.03735L10.9566 10.6026H9.91309L10.9566 12.6895L8.86961 11.646V12.6895L7.82617 13.2112L9.91309 14.2547L9.39138 15.2982H11.4783V16.8634H12.5218V15.2982H14.6088L14.087 14.2547Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4029_4197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.689453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/canada.68fce2d3fd35ae30ec44a4c1b68410f3.svg";
export { ForwardRef as ReactComponent };